import React, {useEffect, useState} from "react";
import {
    Alert,
    Box,
    Button,
    Container, FormControl,
    Grid, InputLabel,
    Paper, Select,
} from "@mui/material";
import MainLayout from "../MainLoyout/MainLayout";
import {useSelector} from 'react-redux'
import Api from "../../Services/Api";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import Skeleton from "@mui/material/Skeleton";
import TextField from '@mui/material/TextField';
import { DatePicker} from '@mui/x-date-pickers-pro';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import Title from "../Title";
import Chart from "./Chart";
import Overview from "./Overview";
import {getStats} from "../../features/app/App";
import {Refresh} from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";

const Dashboard = () => {


    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );

    const stats = useSelector((state) => state.app.stats);
    const startDateState = useSelector((state) => new Date(state.app.stats.startDate));
    const endDateState = useSelector((state) => new Date(state.app.stats.endDate));

    const [startDate, setStartDate] = useState(startDateState);
    const [endDate, setEndDate] = useState(endDateState);
    const [supplyFeedId, setSupplyFeedId] = useState(useSelector((state) => state.app.stats.supplyFeedId));

    const [loading, setLoading] = useState(false);

    const [pageSize, setPageSize] = React.useState(100);
    const [supplyFeeds, setSupplyFeeds] = React.useState([]);


    useEffect(() => {

        loadData()
    }, []);

    const loadData = async () => {
        await Api.supply().then(r => setSupplyFeeds(r))
    }


    const formatNumber = (value) => {
        if (isNaN(value) || value === null) return 0
        const valueFormatted = parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        return `${valueFormatted}`;
    }

    const columns = [
        {field: "date", headerName: "Date", minWidth: 100, flex: 0.4},
        {
            field: "searches",
            headerName: "Searches",
            minWidth: 150,
            type: 'number',
            editable: false,
            flex: 0.6,
            valueFormatter: (params) => {

                const valueFormatted = formatNumber(params.value)
                return valueFormatted;
            }
        },
        {
            field: "monetized_searches",
            headerName: "Monetized Searches",
            minWidth: 200,
            type: 'number',
            editable: false,
            flex: 0.6,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value)
                return valueFormatted;
            }
        },
        {
            field: "clicks",
            headerName: "Clicks",
            minWidth: 100,
            type: 'number',
            flex: 0.5,
            editable: false,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value)
                return valueFormatted;
            }
        },
        {
            field: "ad_coverage",
            headerName: "Ad Coverage",
            minWidth: 120,
            flex: 0.4,
            type: 'number',
            editable: false,
            valueFormatter: (params) => {
                if (params.value == null) {
                    return '0';
                }
                const valueFormatted = Number(params.value).toFixed(2).toLocaleString();
                return `${valueFormatted}%`;
            }
        },
        {
            field: "CTR",
            headerName: "CTR",
            minWidth: 90,
            flex: 0.3,
            type: 'number',
            editable: false,
            valueFormatter: (params) => {
                if (params.value == null) {
                    return '0';
                }
                const valueFormatted = Number(params.value).toFixed(2).toLocaleString();
                return `${valueFormatted}%`;
            }
        },
        {
            field: "RPC",
            headerName: "RPC",
            minWidth: 90,
            flex: 0.3,
            type: 'number',
            editable: false,
            valueFormatter: (params) => {
                if (params.value == null) {
                    return '0';
                }
                const valueFormatted = Number(params.value).toFixed(2).toLocaleString();
                return `$${valueFormatted}`;
            }
        },
        {
            field: "RPM",
            headerName: "RPM",
            minWidth: 90,
            flex: 0.3,
            type: 'number',
            editable: false,
            valueFormatter: (params) => {
                if (params.value == null) {
                    return '0';
                }
                const valueFormatted = Number(params.value).toFixed(2).toLocaleString();
                return `$${valueFormatted}`;
            }
        },

        {
            field: "revenue",
            headerName: "Revenue",
            minWidth: 150,
            flex: 0.6,
            type: 'number',
            editable: false,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value)
                return `$${valueFormatted}`;
            }
        },
    ];


    const onFilter = () => {
        let data = {end: endDate, start: startDate, supply_feed_id: supplyFeedId}
        setLoading(true)
        getStats(data).then(() => {
            setLoading(false)
        })
    }


    const onRefreshHandle = () => {
        let data = {end: endDate, start: startDate, supply_feed_id: supplyFeedId}
        setLoading(true)
        getStats(data).then(() => {
            setLoading(false)
        })

    }


    return (
        <MainLayout title={"Dashboard"}>
            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Grid container spacing={3}>

                    {/* Chart */}
                    <Grid item xs={12} md={8} lg={9}>
                        <Paper
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                height: 200,
                            }}
                        >
                            <Chart data={Object.values(stats.graph).reverse()}/>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={4} lg={3}>
                        <Paper
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                height: 200,
                            }}
                        >
                            <Overview revenueThisMonth={stats.thisMonth} revenueLastMonth={stats.lastMonth}></Overview>

                        </Paper>
                    </Grid>


                    <Grid item xs={12}>
                        <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>
                            <Title>Stats</Title>
                            <Grid container spacing={2} alignItems="center">

                                <Grid item>

                                    <FormControl sx={{ minWidth: 250 }}   size={"small"}>
                                        <InputLabel id="supply_feed_id">Supply Feeds</InputLabel>
                                        <Select
                                            labelId="supply_feed_id"
                                            id="supply_feed_id"
                                            label="Supply Feeds"
                                            value={supplyFeedId ?? ''}
                                            name="supply_feed_id"
                                            onChange={(event) => setSupplyFeedId(event.target.value)}
                                        >
                                            <MenuItem value={''}>
                                                <em>None</em>
                                            </MenuItem>
                                            {supplyFeeds?.map((item) => (<MenuItem key={item.id}
                                                                                   value={item.id}>{item.id} - {item.name}</MenuItem>))}

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Start Date"
                                            name="date_from"
                                            value={startDate ?? ''}
                                            slotProps={{ textField: { size: 'small' } }}
                                            onChange={(value) => setStartDate(value)}
                                            textField={(params) => <TextField {...params} size="small" />}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                <Grid item>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            name="date_to"
                                            label="End Date"
                                            value={endDate ?? ''}
                                            slotProps={{ textField: { size: 'small' } }}
                                            onChange={(value) => setEndDate(value)}
                                            textField={(params) => <TextField size="small" {...params} />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained"   onClick={onFilter}>Filter</Button>

                                </Grid>
                                <Grid item>

                                    <Button variant="contained"   endIcon={<Refresh />} onClick={onRefreshHandle}>
                                        Refresh
                                    </Button>

                                </Grid>


                            </Grid>

                                    <DataGrid
                                        rows={!loading ? Object.values(stats.query) : []}
                                        columns={columns}
                                        pageSize={pageSize}
                                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                        //autoHeight={true}
                                        //sx={{minHeight: 1200}}
                                        getRowId={(row) => row.date}
                                        disableSelectionOnClick
                                        disableColumnSelector
                                        sx={{
                                            mt: 2,
                                            mb: 2,
                                            height: '600px'
                                        }}
                                        density={"compact"}
                                        components={{
                                            LoadingOverlay: LoadingSkeleton,
                                            Toolbar: GridToolbar,
                                        }}
                                        loading={loading}
                                    />



                        </Paper>
                    </Grid>
                </Grid>
            </Container>


        </MainLayout>

    )
}


export default Dashboard